import { ICreateHOPlan } from 'interfaces/HOPlan/HOPlan';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';

export interface IParams {
  page: number;
  pageSize: number;
  year?: number;
  plantId?: string;
  typeRevenue?: string;
}

export interface IGetTrackRevenueHo {
  skip: number;
  take: number;
  plantId?: string;
  typeRevenue?: string;
  year: number;
  fromMonth: number;
  toMonth: number;
  export?: { headerRow: ColumnsTypeCustom };
}

export interface ICalculateRevenueHoTeamsale {
  year: number;
  plantId: string[];
}

export interface IGetTrackRevenueHoDetail {
  plantId?: string;
  year: number;
}

export const HOPLAN_VARIABLE = {
  getListHOPlan: (params: IParams) => {
    const { page, pageSize, year, plantId, typeRevenue } = params;

    return {
      input: {
        ...(year && { year: { equals: year } }),
        ...(typeRevenue && { typeRevenue: { equals: typeRevenue } }),
        plantId: {
          ...(plantId && { equals: plantId }),
        },
        approvalYn: { equals: true },
      },
      take: pageSize,
      skip: (page - 1) * pageSize,
    };
  },
  detail: (id: any) => {
    return {
      input: {
        id: {
          equals: id,
        },
      },
    };
  },
  updateHOPlan: (data: ICreateHOPlan[]) => {
    return { input: data };
  },
  createHOPlan: (data: ICreateHOPlan[]) => {
    return { input: data };
  },
  deleteHOPlan: (id: any) => {
    return {
      id: id,
    };
  },

  checkExisted: (params: Pick<IParams, 'year' | 'plantId' | 'typeRevenue'>) => {
    const { plantId, year, typeRevenue } = params;

    return {
      input: {
        plantId: { equals: plantId },
        year: { equals: year },
        typeRevenue: { equals: typeRevenue },
      },
    };
  },
  getRevenueHOYearByPlant: (params: { year: string; plantId: string }) => {
    return {
      input: {
        plantId: {
          equals: params.plantId,
        },
        year: {
          equals: params.year,
        },
      },
    };
  },
  getRevenueHOPlanByYear: (year: string) => {
    return {
      input: {
        year: {
          equals: year,
        },
      },
    };
  },
  getProgressRevenuePlant: ({ year }: { year: string }) => {
    return {
      input: {
        year,
      },
    };
  },
  getProgressRevenuePlantBranch: ({
    year,
    plant,
  }: {
    year: string;
    plant: string;
  }) => {
    return {
      input: {
        year,
        plant,
      },
    };
  },
  getProgressRevenuePlantTeamSale: ({
    plant,
    teamId,
    year,
  }: {
    year: string;
    plant: string;
    teamId: string;
  }) => {
    return {
      input: {
        year,
        plant,
        teamId,
      },
    };
  },
  // get Track Revenue Ho
  getTrackRevenueHo: ({
    fromMonth,
    skip,
    take,
    toMonth,
    year,
    plantId,
    typeRevenue,
  }: IGetTrackRevenueHo) => {
    return {
      skip,
      take,
      input: {
        year,
        fromMonth,
        toMonth,
        ...(plantId && { plantId }),
        ...(typeRevenue && { typeRevenue }),
      },
    };
  },
  // calculate Revenue Ho Teamsale
  calculateRevenueHoTeamsale: (input: ICalculateRevenueHoTeamsale) => {
    return {
      input,
    };
  },
  // get Track Revenue Ho Detail
  getTrackRevenueHoDetail: ({ year, plantId }: IGetTrackRevenueHoDetail) => {
    return {
      input: {
        plantId: plantId ?? null,
        year,
      },
    };
  },
};
